import PageLayout from 'pages/CreateRubricManual/PageLayout';
import PageProvider from 'pages/CreateRubricManual/PageProvider';

const CreateRubricManualPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default CreateRubricManualPage;
